<nav class="navbar navbar-expand-md navbar-dark header-content ">
  <a class="navbar-brand col-md-2" routerLink="/pet"><img alt="PawsNme" src="../../../assets/images/logoR_white.png"
      class="logo-header"></a>
  <!-- <section class="rightButtons d-inline-block">
    <span class="switchToggle d-none" *ngIf="isLoggedIn">
      <span class="textSwitch">In Clinic</span>
      <input type="checkbox" id="clinicToggle" [(ngModel)]="clinicToggle" (change)="toggleDoctor()">
      <label for="clinicToggle"></label>
    </span>
    <span class="switchToggle" *ngIf="isLoggedIn">
      <span class="textSwitch">CALL</span>
      <input type="checkbox" id="phoneToggle" [(ngModel)]="phoneToggle" (change)="toggleDoctor()">
      <label for="phoneToggle"></label>
    </span>
  </section>
  <section class="doctorList d-inline-block float-right mr-2" *ngIf="enableCheckup">
    <div class="btn-group">
      <input type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false" value="{{action}}" />
      <ul class="dropdown-menu">
        <ng-container *ngFor="let item of doctorList">
          <li class="dropdown-item" (click)="doctorChanged(item)">{{item?.name}}</li>
        </ng-container>
      </ul>
    </div>
  </section> -->
</nav>
